import createAsyncReducer from '@/store/createAsyncReducer.js';
import initialStateReducer from "~/store/initialStateReducer.js";

const siteConfigReducer = createAsyncReducer({
    name: 'siteConfig',
    initialState: {},
    extraReducers: (builder) => {
        builder.addCase(initialStateReducer.actions.setInitialState.fulfilled, (state, action) => {
            const siteConfig = action.payload.site_config;
            return { ...state, ...siteConfig };
        });
    }
});

export default siteConfigReducer;